<mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block" [class.component-dark-theme]="isToggled">
    <mat-card-header>
        <mat-card-title>
            <h5 class="mb-0">
              {{ isEditMode ? 'Izmjena Natječaja' : 'Registracija Natječaja' }}
            </h5>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <form [formGroup]="grantForm" (ngSubmit)="onSubmit()">
    
        <mat-form-field class="mb-25">
          <mat-label>Naziv Natječaja</mat-label>
          <input matInput formControlName="name">
        </mat-form-field>
  
        <mat-form-field class="mb-25">
          <mat-label>Godina</mat-label>   
          <input matInput formControlName="year" type="number"> 
        </mat-form-field>

        <app-editor [formControl]="descriptionControl"></app-editor>

        <br/>

        <mat-form-field class="mb-25">
          <mat-label>Vrijedi do</mat-label>
          <input matInput [matDatepicker]="picker" formControlName="validUntil">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

        <file-upload class="file-uploader" [control]="fileUploadControl"></file-upload>

        <br/>
    
        <button mat-raised-button color="primary" type="submit" [disabled]="grantForm.invalid">
          {{ isEditMode ? 'Ažuriraj natječaj' : 'Kreiraj natječaj' }}
        </button>
      </form>
    </mat-card-content>
  </mat-card>